import React from 'react';
import { Phone, Sparkles, Instagram } from 'lucide-react';
import { motion } from 'framer-motion';
export function Hero() {
  return <section id="inicio" className="relative bg-black pt-20 pb-20 md:pb-28 overflow-hidden" data-id="element-353">
      {/* Cinematic ambient glows */}
      <div className="absolute top-[20%] left-[10%] w-[40%] h-[40%] bg-gold/10 rounded-full blur-[140px] pointer-events-none" data-id="element-354"></div>
      <div className="absolute bottom-[10%] right-[5%] w-[35%] h-[35%] bg-amber-500/5 rounded-full blur-[160px] pointer-events-none" data-id="element-355"></div>

      {/* Banner as cinematic backdrop — blended into the page */}
      <div className="relative w-full" data-id="element-356">
        <motion.div initial={{
        opacity: 0,
        scale: 1.05
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 1.4,
        ease: 'easeOut'
      }} className="relative w-full mx-auto" style={{
        // Soft feathered mask: fade top, bottom, and sides into the black bg
        WebkitMaskImage: 'radial-gradient(ellipse 90% 80% at 50% 45%, black 55%, transparent 100%)',
        maskImage: 'radial-gradient(ellipse 90% 80% at 50% 45%, black 55%, transparent 100%)'
      }} data-id="element-357">
          <img src="https://cdn.magicpatterns.com/uploads/cBg72FDdyXBLU6nsEWAZjU/bannerceleb2.png" alt="Celebrate Events — Mirror Photo Booth con abuela y novia" className="w-full h-auto block max-h-[80vh] object-cover object-center mx-auto" data-id="element-358" />

          {/* Subtle film grain / cinematic warm glow on top of the banner */}
          <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-transparent to-black/80 pointer-events-none" data-id="element-359"></div>
          <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-transparent pointer-events-none" data-id="element-360"></div>
        </motion.div>

        {/* Floating sparkles (decorative cinematic dust) */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 2,
        delay: 0.6
      }} className="absolute inset-0 pointer-events-none" data-id="element-361">
          <Sparkles className="absolute top-[20%] left-[15%] w-4 h-4 text-gold/40 animate-pulse" data-id="element-362" />
          <Sparkles className="absolute top-[60%] right-[20%] w-5 h-5 text-gold/30 animate-pulse" style={{
          animationDelay: '1s'
        }} data-id="element-363" />
          <Sparkles className="absolute top-[35%] right-[12%] w-3 h-3 text-gold/50 animate-pulse" style={{
          animationDelay: '2s'
        }} data-id="element-364" />
          <Sparkles className="absolute bottom-[15%] left-[25%] w-3 h-3 text-gold/40 animate-pulse" style={{
          animationDelay: '0.5s'
        }} data-id="element-365" />
        </motion.div>
      </div>

      {/* Headline + CTAs — sits cinematically beneath, blended with banner fade */}
      <div className="container mx-auto px-4 md:px-6 relative z-10 -mt-12 md:-mt-20" data-id="element-366">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.9,
        delay: 0.5,
        ease: 'easeOut'
      }} className="max-w-4xl mx-auto text-center" data-id="element-367">
          <motion.h2 initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.7
        }} className="font-script text-3xl md:text-5xl text-gold mb-4 drop-shadow-[0_0_25px_rgba(212,175,55,0.4)]" data-id="element-368">
            Recuerdos que duran toda la vida
          </motion.h2>

          <h1 className="font-serif text-2xl md:text-4xl lg:text-5xl font-bold text-cream leading-tight mb-6 drop-shadow-[0_4px_20px_rgba(0,0,0,0.9)]" data-id="element-369">
            ¿Y si pudieras llevarte a casa un álbum de fotos impresas de tus
            mejores recuerdos de ese día tan especial?
          </h1>

          <p className="text-base md:text-xl text-cream/80 mb-10 max-w-2xl mx-auto font-light italic drop-shadow-[0_2px_10px_rgba(0,0,0,0.8)]" data-id="element-370">
            Mirror Photo Booth de lujo para bodas, quinceañeras y graduaciones
            en Atlanta.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-371">
            <a href="#reservar" className="flex items-center justify-center gap-2 bg-gold hover:bg-gold-light text-ink px-8 py-4 rounded-full font-bold text-lg transition-all hover:shadow-[0_0_30px_rgba(212,175,55,0.6)] hover:-translate-y-1" data-id="element-372">
              <Phone size={20} data-id="element-373" />
              <span data-id="element-374">Reserva tu Fecha</span>
            </a>

            <a href="tel:+14049409785" className="flex items-center justify-center gap-2 border-2 border-gold/70 text-gold hover:bg-gold/10 backdrop-blur-sm px-8 py-4 rounded-full font-bold text-lg transition-all" data-id="element-375">
              <span data-id="element-376">Llámanos: (404) 940-9785</span>
            </a>
          </div>

          <a href="https://instagram.com/celebrateyp" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 mt-8 text-gold hover:text-gold-light transition-all group" data-id="element-377">
            <Instagram className="w-5 h-5 group-hover:drop-shadow-[0_0_10px_rgba(212,175,55,0.7)] transition-all" data-id="element-378" />
            <span className="font-script text-2xl" data-id="element-379">@celebrateyp</span>
            <span className="text-cream/50 text-sm font-light hidden sm:inline" data-id="element-380">
              · Síguenos
            </span>
          </a>
        </motion.div>
      </div>
    </section>;
}